import React from "react";
import highradius2 from "../../Images/HRC.svg";
import { myUtilities } from "../../Utils";
import * as DOMPurify from 'dompurify';
class TopBuildFooter extends React.Component {
  render() {
    return (
      <div className={DOMPurify.sanitize(this.props.parent) + " topbuild-header-footer footer-div"}>
        <div className="footer-logo-div">
          {myUtilities.accountSpecificLanguage("refreshFooterAlert", "Do not refresh or click browser back")}
        </div>
        <div className="footer-logo-div">
          {myUtilities.accountSpecificLanguage("poweredby", "Powered By" )}
          <img className="static-footer-logo" src={highradius2} alt="Highradius Logo" />
        </div>
      </div>
    );
  }
}

export default TopBuildFooter;
